module.exports = __webpack_public_path__ + "static/product_sans_bold-webfont-d058cc102ae3b0fc489c35741e644ce2.woff2";